import { Box } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";

import ScrollToTopIcon from "../scrollToTopIcon/scrollToTopIcon";

const FloatButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 500) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box
      position="fixed"
      bottom="100px"
      right={{
        md: "50px",
        base: "15px",
      }}
      zIndex={999999}
      display="flex"
      flexDirection="column"
      gap="10px"
      alignItems="center"
    >
      {showScrollToTop && <ScrollToTopIcon handleScrollTop={handleScrollTop} />}
    </Box>
  );
};

export default FloatButton;
